'use client'

import { useRef } from 'react'
import { useSearchParams } from 'next/navigation'
import { toProjectType, useSessionStore } from '@/app/store/session'

// Stores the Entry parameters and the Contact token of the entry link in the session
export default function LoadContact({
  children
}: {
  children: React.ReactNode
}) {
  const searchParams = useSearchParams()
  // Query string already stored: a render with the same link writes nothing, so subscribed components are not updated while this one renders
  const storedSearch = useRef<string | null>(null)
  if (storedSearch.current === searchParams.toString()) return children
  storedSearch.current = searchParams.toString()

  const { updateEntryParameters, startNewSession, openRestoreSession } =
    useSessionStore.getState()

  const projectType = searchParams.get('flow')
  if (projectType) startNewSession(toProjectType(projectType))

  const partnerDeal = searchParams.get('partnerDeal')
  if (partnerDeal === '1') {
    updateEntryParameters({ partnerDeal: true })
  }

  const securityToken = searchParams.get('token')
  if (securityToken) openRestoreSession(securityToken)

  const partnerToken = searchParams.get('partner')
  if (partnerToken) {
    updateEntryParameters({ partnerToken })
  }

  const addressId = searchParams.get('address')
  if (addressId) {
    updateEntryParameters({ addressId })
  }

  const cityId = searchParams.get('city')
  if (cityId) {
    updateEntryParameters({ cityId })
  }

  const legalStatusId = searchParams.get('legalStatus')
  if (legalStatusId) {
    updateEntryParameters({ legalStatusId })
  }

  const promoCode = searchParams.get('promoCode')
  if (promoCode) {
    updateEntryParameters({ promoCode })
  }

  const utmSource = searchParams.get('utm_source')
  if (utmSource) {
    updateEntryParameters({ utmSource })
  }

  const utmMedium = searchParams.get('utm_medium')
  if (utmMedium) {
    updateEntryParameters({ utmMedium })
  }

  const utmCampaign = searchParams.get('utm_campaign')
  if (utmCampaign) {
    updateEntryParameters({ utmCampaign })
  }

  return children
}
